// @flow
import Spinner from 'components/Spinner'
import * as React from 'react'
import tw from 'tailwind-styled-components'

import ListItem from './ListItem'

type Props = {
  children: React.Node,
  headerText?: string,
  hideHeader?: boolean,
  loading?: boolean,
  $scrollable?: boolean,
}

const ListWrapper: React.ComponentType<Props> = tw.div`
  bg-white
  md:rounded
  border
  border-gray-400

  ${(props: Props) => {
    if (props.$scrollable) {
      return `
        max-h-1/2
        overflow-auto
      `
    }

    return ''
  }}
`

const ListHeader: React.ComponentType<Props> = tw.div`
  py-3
  px-4
  flex
  justify-between
  items-center
  text-xs
  leading-4
  font-medium
  text-gray-500
  uppercase
  tracking-wider
  border-b
  border-gray-200
  w-full
  bg-gray-50
`

function List({
  headerText,
  hideHeader,
  children,
  loading,
  $scrollable,
}: Props): React.Node {
  return (
    <ListWrapper $scrollable={$scrollable}>
      {hideHeader && (
        <ListHeader>
          <span>{headerText}</span>{' '}
          {loading && <Spinner color="onLight" size={16} />}
        </ListHeader>
      )}
      {children}
    </ListWrapper>
  )
}

List.Item = ListItem

export default List
